import React from 'react';
import { t } from '../../../../modules/infra/i18n';

export default () => (
  <h3 className="u-fontsize-medium u-text-center u-mt+">{t('barber:deleted_staff.empty_message')}</h3>
);
